// Delivery Address Section Component
import React, { useEffect, useState } from "react";
import { useOrder } from "../context/OrderContext";
import { useAuth } from "../context/AuthContext";
// Types
import api from "../services";
import uber from "../../src/assests/uber-icon.svg";
import doorDash from "../../src/assests/DASH.svg";
import VideoLoader from "./VideoLoader";
import Locationicon from "../assests/loc.png";
import { useDelivery } from "../context/DeliveryContext";
import { AddressModals, TimePickerModal , type Location} from "../pages/pos/MenuModals";
import { Building2, Clock3, NotepadText } from "lucide-react";
import DeliveryInstructionsModal from "./InstructionsModal";
import toast from "react-hot-toast";

interface CartItem {
  id: string;
  name: string;
  restaurant: string;
  price: number;
  quantity: number;
  isVeg: boolean;
  customizations?: string[];
  image?: string;
}

interface BillDetails {
  itemTotal: number;
  deliveryFee: number;
  toPay: number;
}

interface Address {
  _id?: string;
  type: "Home" | "Office" | "Others";
  tag?: string;
  FlatBlock?: string;
  Area?: string;
  latitude?: number;
  longitude?: number;
}

interface DeliveryAddressSectionPageProps {
  totalTime: number;
  deliverable?: boolean;
  deliveryStatusLoading?: boolean;
  doordashDeliveryTime?: number;
  doordashDeliverable?: boolean;
  uberDeliveryFee?: number;
  doorDashDeliveryFee?: number;
  selectedPlatform: "uber" | "doordash" | "custom" | null;
  setSelectedPlatform: React.Dispatch<
    React.SetStateAction<"uber" | "doordash" | "custom" | null>
  >;
  hideDeliveryPartnerOptions?: boolean;
  inlineStyle?: boolean;
 onResetDelivery?: () => void;
}
export const DeliveryAddressSection: React.FC<
  DeliveryAddressSectionPageProps
> = ({
  totalTime,
  deliverable,
  deliveryStatusLoading,
  doordashDeliverable,
  doordashDeliveryTime,
  uberDeliveryFee,
  doorDashDeliveryFee,
  selectedPlatform,
  setSelectedPlatform,
  hideDeliveryPartnerOptions = false,
  inlineStyle = false,
  onResetDelivery
}) => {
  const {
    deliveryAddress,
    setDeliveryAddress,
    selectedAddressTag,
    setSelectedAddressTag,
    pickup,
    delivery,
      orderType,
    setOrderType,
    pickupLocation,
    pickupTime,
    deliveryTime,
    setPickupLocation,
    deliveryDate,
    setDeliveryDate,
    pickupDate,
    setPickupDate,
    setPickupTime,
    setDeliveryTime,
  } = useDelivery();
  const [addresses, setAddresses] = useState<Address[]>([]);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [iseditOpen, seteditModalOpen] = useState(false);
  const { orderData, setOrderData } = useOrder();
  const { user, isAuth, currencySymbol } = useAuth();
  const [loading, setLoading] = useState(true);

  // State for address input in the modal
  const [flatBlock, setFlatBlock] = useState("");
  const [area, setArea] = useState("");
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [tag, setTag] = useState("");
  const [fullMapAddress, setFullMapAddress] = useState("");

  // State for editing
  const [editingAddressId, setEditingAddressId] = useState<string | null>(null);

  type ButtonType = "Home" | "Office" | "Others";
  const [selectedButton, setSelectedButton] = useState<ButtonType | "">("");
  const [isTimeModalOpen, setIsTimeModalOpen] = useState(false);
  const [selectedTimemodal, setselectedTimemodal] = useState(false);
  const [selectedAddress, setselectedAddress] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
  const handleScheduleClick = () => {
    setIsTimeModalOpen(true);
  };
  const [selectedLocationObject, setSelectedLocationObject] =
    useState<Location | null>(null);

  const handleButtonClick = (button: ButtonType) => {
    if (selectedButton === button) {
      setSelectedButton("");
      setTag("");
    } else {
      setSelectedButton(button);
      setTag(button);
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [savedInstructions, setSavedInstructions] = useState('');

  const handleSave = (instructions: string) => {
    setSavedInstructions(instructions);
    console.log('Saved instructions:', instructions);
  };

  // Handle location change from MapWithSearch
  const handleLocationChange = (data: {
    address: string;
    lat: number;
    lng: number;
    flatBlock?: string;
    area?: string;
    fullAddress?: string;
  }) => {
    setLatitude(data.lat);
    setLongitude(data.lng);

    if (data.fullAddress) {
      setFullMapAddress(data.fullAddress);
    }

    if (data.flatBlock) {
      setFlatBlock(data.flatBlock);
    }
    if (data.area) {
      setArea(data.area);
    }

    // Update order context
    setOrderData((prev: any) => ({
      ...prev,
      location: {
        address: data.address,
        lat: data.lat,
        lng: data.lng,
      },
    }));
  };

  // Fetch user addresses when user is authenticated
  useEffect(() => {
    if (!user?.id || !isAuth) return;
    setLoading(true);
    const fetchUserData = async () => {
      try {
        const res = await api.get(`${process.env.REACT_APP_API_URL}/address`);
        setAddresses(res.data.addresses);
      } catch (error) {
        console.error("Error fetching address", error);
      }
      setLoading(false);
    };

    fetchUserData();
  }, [user?.id, isAuth]);

  // Reset form fields
  const resetForm = () => {
    setFlatBlock("");
    setArea("");
    setLatitude(0);
    setLongitude(0);
    setSelectedButton("");
    setTag("");
    setFullMapAddress("");
    setEditingAddressId(null);
  };

  // Handle opening edit modal
  const handleEditClick = (addr: Address) => {
    console.log("address", addr);
    setEditingAddressId(addr._id || null);
    setFlatBlock(addr.FlatBlock || "");

    // Extract area from combined address if needed
    //const areaOnly = addr.Area ? addr.Area.split(",")[0].trim() : "";
    setArea(addr.Area || "");

    setLatitude(addr.latitude || 0);
    setLongitude(addr.longitude || 0);
    setSelectedButton(addr.type as ButtonType);
    setTag(addr.tag || "");
    seteditModalOpen(true);
  };

  const handleDelete = async (id?: string) => {
    if (!id) {
      console.error("Error Deleting addressid");
      return;
    }

    try {
      await api.delete(`${process.env.REACT_APP_API_URL}/address/${id}`);
      setAddresses((prev) => prev.filter((a) => a._id !== id));

      const deletedAddress = addresses.find((a) => a._id === id);
      if (deliveryAddress && deletedAddress) {
        setDeliveryAddress("");
        setOrderData((prev) => ({
          ...prev,
          location: {
            address: "",
            lat: 0,
            lng: 0,
          },
        }));
      }
    } catch (error) {
      console.error("Error deleting address", error);
      toast.error("Failed to delete address");
    }
  };

  // Handle address submission (add new)
  const handleAddressSubmit = async () => {
    if (!flatBlock || !area || !selectedButton) {
      toast.error("Please fill out all fields");
      return;
    }

    if (!latitude || !longitude) {
      toast.error("Please select a location on the map");
      return;
    }

    const combinedAddress = `${area ? area + ", " : ""}${fullMapAddress}`;

    const newAddress = {
      userId: user?.id,
      type: selectedButton,
      tag: selectedButton === "Others" ? tag : "",
      FlatBlock: flatBlock,
      Area: combinedAddress,
      latitude,
      longitude,
    };

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/address`,
        newAddress,
      );
      setAddresses((prev) => [...prev, response.data.address]);

      resetForm();
      setIsAddressModalOpen(false);
    } catch (error) {
      console.error("Error adding address:", error);
      toast.error("Failed to add address");
    }
  };

  // Handle address edit submission
  const handleEditAddress = async () => {
    if (!flatBlock || !area || !selectedButton) {
      toast.error("Please fill out all fields");
      return;
    }

    if (!latitude || !longitude) {
      toast.error("Please select a location on the map");
      return;
    }

    if (!editingAddressId) {
      toast.error("No address selected for editing");
      return;
    }

    const combinedAddress = `${area ? area + ", " : ""}${fullMapAddress}`;

    const updatedAddress = {
      type: selectedButton,
      tag: selectedButton === "Others" ? tag : "",
      FlatBlock: flatBlock,
      Area: combinedAddress,
      latitude,
      longitude,
    };

    try {
      const response = await api.put(
        `${process.env.REACT_APP_API_URL}/address/${editingAddressId}`,
        updatedAddress,
      );

      // Update the addresses array with the edited address
      setAddresses((prev) =>
        prev.map((addr) =>
          addr._id === editingAddressId ? response.data.address : addr,
        ),
      );

      // If this was the selected address, update it
      const currentAddr = addresses.find((a) => a._id === editingAddressId);
      if (
        currentAddr &&
        deliveryAddress == `${currentAddr.FlatBlock}, ${currentAddr.Area}`
      ) {
        setDeliveryAddress(`${flatBlock}, ${combinedAddress}`);
        setOrderData((prev) => ({
          ...prev,
          location: {
            address: `${flatBlock}, ${combinedAddress}`,
            lat: latitude,
            lng: longitude,
          },
        }));
      }

      resetForm();
      seteditModalOpen(false);
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };
  useEffect(() => {
    console.log(`,s`, deliverable);
  }, [deliverable]);

  if (loading && user?.id && isAuth) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50 m-0">
        <VideoLoader size="medium" />
      </div>
    );
  }

  return (
    <>
      <div
        className={`bg-white rounded-lg   mb-6 mt-0 ${inlineStyle ? "p-[1px] pt-[2px]" : "p-5 pt-0"}`}
      >
       <div className={`w-full bg-white py-4 px-4 border-[1px] border-black/10 rounded-[15px] overflow-hidden dm-checkout-section ${(orderType === "delivery" && deliveryAddress) || (orderType === "pickup" && pickupLocation) ? "rounded-bl-none rounded-br-none" : ""}`}>
          <div className="flex items-center justify-between w-full ">
            <div className="flex items-center gap-2 w-full">
              <div
                className={` p-2 bg-transparent w-[45px] h-[45px] border-[1px] border-black/20 rounded-full flex items-center justify-center`}
              >
                {orderType === "delivery" ? (
                    <img src={Locationicon} alt="Addresses" className="w-5 h-5 dm-icon-invert" />
                  ) : (
                    <Building2 size={16} className="sm:w-[18px] sm:h-[18px] shrink-0 dm-back-icon" />
                  )}
              </div>
              <div className="flex justify-between items-center w-full">
                <h3
                className={`font-semibold text-[18px] sm:text-[20px] mb-0 ${
                  user && isAuth
                    ? "text-black"
                    : "text-black/70"
                }`}
              >
                {orderType === "pickup" ? "Pickup details" : "Delivery address"}
              </h3>
                <div>
      <div className="relative flex bg-white rounded-full p-1 w-fit border border-black/20 dm-toggle">
        <span
          className={`absolute top-1 bottom-1 rounded-full bg-black dm-toggle-indicator 
        transition-all duration-300 ease-out
        ${orderType === "delivery" ? "left-1/2 right-1" : "left-1 right-1/2"}`}
        />

                        <button
                          onClick={() => {
                            setOrderType("pickup");
                            setIsAddressModalOpen(true);
                          }}
                          className={`relative z-10 px-3 sm:px-4 py-1.5 text-xs sm:text-sm font-medium rounded-full transition-colors duration-200 ${
                            orderType === "pickup" ? "text-white dm-toggle-selected" : "text-black dm-toggle-unselected"
                          } dm-toggle-btn`}
                        >
                          Pickup
                        </button>
                        <button
                          onClick={() => {
                            setOrderType("delivery");
                            setIsAddressModalOpen(true);
                          }}
                          className={`relative z-10 px-3 sm:px-4 py-1.5 text-xs sm:text-sm font-medium rounded-full transition-colors duration-200 ${
                            orderType === "delivery" ? "text-white dm-toggle-selected" : "text-black dm-toggle-unselected"
                          } dm-toggle-btn`}
                        >
                          Delivery
                        </button>
                      </div>
    </div>
              </div>
              
            </div>
          </div>
        </div>

        {(orderType === "delivery" && !deliveryAddress) || (orderType === "pickup" && !pickupLocation) ? (
          <>
            {/* <div className="w-full py-8 px-4 border-t-0 rounded-l-none rounded-r-none bg-white border-[1px] border-[rgba(238,238,238,1)] rounded-[15px] overflow-hidden">
              <div className="text-center">
                <p className="text-gray-600 mb-2">Address selection temporarily disabled</p>
                <p className="text-sm text-gray-500">Please use the modal to select your {orderType} location</p>
              </div>
            </div> */}
            <div className="flex items-center justify-between gap-3 border-[1px] p-4 border-black/10 border-t-0 rounded-tl-none rounded-tr-none bg-white rounded-[15px] dm-checkout-section">
              <span className="text-sm text-red-600">
                {orderType === "pickup"
                  ? "Select a pickup location to continue to payment."
                  : "Enter your delivery address to continue to payment."}
              </span>
              <button
                type="button"
                onClick={() => setIsAddressModalOpen(true)}
                className="font-semibold text-black underline"
              >
                {orderType === "pickup" ? "Select" : "Add address"}
              </button>
            </div>
          </>
        ) : (
          <div className="bg-white ">
            <div className=" border-[1px] p-4 border-black/10 border-t-0
             rounded-tl-none rounded-tr-none bg-white rounded-[15px] dm-checkout-section">
             
            <div className="flex items-start justify-between ">
              <div>
                <div className="flex items-center gap-1">
                  <span  >{orderType === "pickup" ? "Pickup from" : "Delivering to"}</span>
                    <p className="text-black font-semibold mb-0">
                  {orderType === "pickup" ? (pickupLocation || "") : deliveryAddress}
                </p>
                </div>
              </div>

              <button
                className="text-black text-sm font-bold"
                onClick={() => {
                    setIsAddressModalOpen(true);
                              }}>
                CHANGE
              </button>
            </div>
             {((orderType === "pickup" && pickupTime) ||
                  (orderType === "delivery" && deliveryTime)) && (
                  <div className="flex items-center gap-1 mt-2 dm-delivery-time">
                    <Clock3 size={16} className="sm:w-[18px] sm:h-[18px] dm-back-icon" />
                    {orderData?.isAsap
                      ? "ASAP"
                      : orderType === "pickup"
                        ? `${pickupDate?.charAt(0).toUpperCase() + pickupDate?.slice(1)} by ${pickupTime}`
                        : `${deliveryDate?.charAt(0).toUpperCase() + deliveryDate?.slice(1)} by ${deliveryTime}`}
                  </div>
                )}
                   {orderType === "delivery" && (
                     <div className="flex items-center gap-1 mt-2">
                   <NotepadText size={16} className="sm:w-[18px] sm:h-[18px] dm-back-icon" />
                    <span className="hover:underline cursor-pointer"
        onClick={() => setIsModalOpen(true)}>
                     {('Delivery Instructions: ' + (delivery.instructions || "")) || "Add Delivery Instructions"} 
                    </span>
                  </div>
                  )}
            </div>
            {orderType === "delivery" && hideDeliveryPartnerOptions && (
              <div className="border-[1px] p-4 sm:p-4 border-black/10 mt-4 bg-white rounded-[15px] dm-checkout-section">
                <p className="font-medium text-[19px] text-black m-0">
                  We handle the delivery for you.
                </p>
              </div>
            )}
            {orderType === "delivery" && !hideDeliveryPartnerOptions && (
            <div className="border-[1px] p-4  sm:p-4 border-black/10 mt-4 bg-white rounded-[15px] dm-checkout-section">
              <div className=" text-sm text-gray-600">
                <div>
                  <p className="font-medium text-[19px] text-black">
                    Choose Delivery Partner
                  </p>

                  <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 mt-2 sm:mt-3">
                    {/* -------------------------
        UBER BUTTON
    -------------------------- */}
                    <button
                      onClick={() => deliverable && setSelectedPlatform("uber")}
                      disabled={!deliverable}
                      className={`
        flex items-center gap-2 px-4 py-3 rounded-xl border-[1px] transition-all w-full dm-platform-card
        ${
          selectedPlatform === "uber"
            ? "border-black bg-white selected"
            : "border-black/10 bg-white"
        }
        ${!deliverable ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50"}
      `}
                    >
                      <img src={uber} alt="Uber" className="w-8 h-8" />

                      <div className="flex flex-col text-left">
                        <span className="font-semibold text-gray-900">
                          Uber
                        </span>

                        {deliverable && !deliveryStatusLoading ? (
                          <span className="text-sm text-gray-600">
                            {orderData?.isAsap && `${totalTime} mins ETA.• `} {currencySymbol}
                            {uberDeliveryFee?.toFixed(2)}
                          </span>
                        ) : (
                          !deliveryStatusLoading && (
                            <span className="text-sm text-red-600">
                              Not Deliverable
                            </span>
                          )
                        )}
                      </div>
                    </button>

                    {/* -------------------------
                            DOORDASH BUTTON
                        -------------------------- */}
                    <button
                      onClick={() =>
                        doordashDeliverable && setSelectedPlatform("doordash")
                      }
                      disabled={!doordashDeliverable}
                      className={`
                          flex items-center gap-2 px-4 py-3 rounded-[15px] border-[1px] transition-all w-full dm-platform-card
                          ${
                            selectedPlatform === "doordash"
                              ? "border-red-500 bg-white selected"
                              : "border-black/10 bg-white"
                          }
                          ${
                            !doordashDeliverable
                              ? "opacity-50 cursor-not-allowed"
                              : "hover:bg-red-50"
                          }
                        `}
                    >
                      <img src={doorDash} alt="DoorDash" className="w-8 h-8" />

                      <div className="flex flex-col text-left">
                        <span className="font-semibold text-gray-900">
                          DoorDash
                        </span>

                        {doordashDeliverable && !deliveryStatusLoading ? (
                          <span className="text-sm text-gray-600">
                            {orderData?.isAsap && `${doordashDeliveryTime} mins ETA.• `} {currencySymbol}
                            {doorDashDeliveryFee?.toFixed(2)}
                          </span>
                        ) : (
                          !deliveryStatusLoading && (
                            <span className="text-sm text-red-600">
                              Not Deliverable
                            </span>
                          )
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            )}
          </div>
        )}
      </div>

      <AddressModals
                            isOpen={isAddressModalOpen}
                            onClose={() => setIsAddressModalOpen(false)}
                            orderType={orderType}
                            setOrderType={setOrderType}
                            selectedLocation={selectedLocation}
                            setSelectedLocation={setSelectedLocation}
                            onLocationObjectSelect={(location) =>
                              setSelectedLocationObject(location)
                            }
                            onScheduleClick={handleScheduleClick}
                            setDeliveryAddress={setDeliveryAddress}
                            setPickupLocation={setPickupLocation}
                            setSelectedAddress={setselectedAddress}
                          />
                          <TimePickerModal
                            isOpen={isTimeModalOpen}
                            onClose={() => {
                              setIsTimeModalOpen(false);
                            }}
                            selectedDate={
                              orderType === "pickup" ? pickupDate : deliveryDate
                            }
                            setSelectedDate={
                              orderType === "pickup" ? setPickupDate : setDeliveryDate
                            }
                            selectedTime={
                              orderType === "pickup" ? pickupTime : deliveryTime
                            }
                            setSelectedTime={
                              orderType === "pickup" ? setPickupTime : setDeliveryTime
                            }
                            selectedLocation={selectedLocationObject}
                            orderType={orderType}
                            setSelectedTimemodal={setselectedTimemodal}
                          />
                            <DeliveryInstructionsModal
                                  isOpen={isModalOpen}
                                  onClose={() => setIsModalOpen(false)}
                                  onSave={handleSave}
                                  initialValue={savedInstructions}
                                />
    </>
  );
};

export default DeliveryAddressSection;
